// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"551":"cf24e243","643":"c9adafaa"}[chunkId] + ".chunk.css";
};